import { useLocation, useNavigate } from 'react-router-dom'
import questionMarkIcon from './images/question-mark-icon-mobile.svg'
import tableIcon from './images/table-icon-active-mobile.svg'
import mapIcon from './images/map-icon-mobile.svg'
//import downArrowIcon from './images/down-arrow-icon.svg'
import { Switch, SwitchProps, styled } from '@mui/material'
import { RoutePath } from '../../constants'
//import { downloadCSV } from '../Table/utils'
import { Organization } from '../../types'

const CustomSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 76,
  height: 42,
  padding: 0,
  border: `1px solid #222222`,
  borderRadius: 21,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 7,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      paddingLeft: 16,
      '& + .MuiSwitch-track': {
        backgroundColor: '#e9e7e1',
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#222222',
      border: '6px solid #222222',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: '#222222',
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.7,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 28,
    height: 28,
    color: '#222222',
  },
  '& .MuiSwitch-track': {
    backgroundColor: '#e9e7e1',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
    width: '100%',
  },
}))

type TableToggleMobileProps = {
  data: Organization[]
  onExplainerStepChange: (step: number) => void
  downloadRef: React.RefObject<HTMLDivElement>
}
function TableToggleMobile({
  data,
  onExplainerStepChange,
  downloadRef,
}: TableToggleMobileProps) {
  const { pathname: viewType } = useLocation()
  const navigate = useNavigate()

  return (
    <div className="fixed bottom-0 left-0 h-[80px] flex items-center justify-center border-t-[1px] border-[#222222] w-full bg-white">
      {/* <div
        className="border-r-[1px] border-[#222222] flex px-8 py-4 justify-center items-center h-full"
        role="button"
        ref={downloadRef}
        onClick={() => downloadCSV(data)}
      >
        <img
          src={downArrowIcon}
          alt="Arrow pointing down"
          width={24}
          height={25}
        />
      </div> */}
      <div className="py-4 px-8 items-center justify-center flex gap-8 flex-1">
        <img src={mapIcon} alt="Folded map" />
        <CustomSwitch
          checked={viewType === RoutePath.Table}
          onChange={() => {
            if (viewType === RoutePath.Map) {
              if (typeof window.gtag === 'function') {
                window.gtag('event', 'view_toggle', { view: 'table' })
              }
              navigate(RoutePath.Table)
            } else {
              if (typeof window.gtag === 'function') {
                window.gtag('event', 'view_toggle', { view: 'map' })
              }
              navigate(RoutePath.Map)
            }
          }}
          inputProps={{ 'aria-label': 'mobile toggle between map and table' }}
        />
        <img src={tableIcon} alt="Excel sheet" />
      </div>
      <div
        className="border-l-[1px] border-[#222222] flex px-8 py-4 justify-center items-center h-full"
        role="button"
        onClick={() => {
          window.scrollTo({
            top: 0,
            left: 0,
          })
          onExplainerStepChange(1)
        }}
      >
        <img
          src={questionMarkIcon}
          alt="Question mark"
          width={42}
          height={42}
        />
      </div>
    </div>
  )
}

export default TableToggleMobile
